import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=c44565a2&"
import script from "./Home.js?vue&type=script&lang=js&"
export * from "./Home.js?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QDialog,QCard,QImg,QNoSsr});
